import { cloneDeep } from 'lodash';
import { makeDataState } from '@/util/dataState';
import type { SurgicalGuideOrdersState } from '@/stores/surgicalGuideOrders/types';

const initialState: SurgicalGuideOrdersState = {
    orders: [],
    ...makeDataState()
};

export const makeInitialState = (): SurgicalGuideOrdersState => {
    // Given the state is not a flat structure, it needs to be deep clone
    // e.g.: $reset will not work if the state is not cloned
    return cloneDeep({
        ...initialState,
    });
};
